module.exports = __webpack_public_path__ + "img/transfer-cert-register.f5f4f1fb.png";